export const unknown = '__autocomplete_unknown__'
export const mouseUp = '__autocomplete_mouseup__'
export const itemMouseEnter = '__autocomplete_item_mouseenter__'
export const keyDownArrowUp = '__autocomplete_keydown_arrow_up__'
export const keyDownArrowDown = '__autocomplete_keydown_arrow_down__'
export const keyDownEscape = '__autocomplete_keydown_escape__'
export const keyDownEnter = '__autocomplete_keydown_enter__'
export const clickItem = '__autocomplete_click_item__'
export const blurInput = '__autocomplete_blur_input__'
export const changeInput = '__autocomplete_change_input__'
export const keyDownSpaceButton = '__autocomplete_keydown_space_button__'
export const clickButton = '__autocomplete_click_button__'
export const blurButton = '__autocomplete_blur_button__'
export const controlledPropUpdatedSelectedItem = '__autocomplete_controlled_prop_updated_selected_item__'
export const touchStart = '__autocomplete_touchstart__'
